import React from 'react';

export const extractText = (node) => {
  if (node == null) return '';
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(extractText).join(' ');
  }
  if (React.isValidElement(node)) {
    return extractText(node.props.children);
  }
  return '';
};

export const filterTableRows = (rows, searchTerm) => {
  if (!searchTerm) return rows;
  const lowerSearch = searchTerm.toLowerCase().trim();
  return rows.filter((row) => {
    const rowText = extractText(row).toLowerCase();
    return rowText.includes(lowerSearch);
  });
};

export const generatePageNumbers = (currentPage, totalPages) => {
  const pages = [];
  const maxVisiblePages = 5;

  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = startPage + maxVisiblePages - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return pages;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Table/utils/tableHelpers.js